import React from "react";
import qs from "qs";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useStartHoursOfCompanyInSeconds from "hooks/useStartHoursOfCompanyInSeconds";
import { DateFilter } from "..";

const DateFilterWrap = ({
	className = "",
	initialDefault = "day",
	dropdownPosition,
	withStartHoursAppended = false,
	canClear = true,
	navigateByDay = true,
	omitKeysOnSelect = []
}) => {
	const location = useLocation();
	const navigate = useNavigate();
	const query = qs.parse(location.search, { ignoreQueryPrefix: true });
	const startHoursInSeconds = useStartHoursOfCompanyInSeconds({
		show: withStartHoursAppended
	});

	const handleClick = (start, end) => {
		const { page, ...rest } = query;
		const cleaned = { ...rest };
		omitKeysOnSelect.forEach(key => {
			delete cleaned[key];
		});
		navigate({
			search: qs.stringify(
				{
					...cleaned,
					filter: query.filter,
					start_at: start,
					end_at: end
				},
				{ encode: false }
			)
		});
	};

	const handleClear = () => {
		const { start_at, end_at, page, ...rest } = query;
		navigate({
			search: qs.stringify(rest, { encode: false })
		});
	};

	const initialValueQuery = query.start_at
		? {
				startOf: query.start_at,
				endOf: query.end_at
		  }
		: null;

	return (
		<div className={className}>
			<DateFilter
				startHoursInSeconds={startHoursInSeconds}
				{...{
					dropdownPosition,
					initialValueQuery,
					initialDefault,
					handleClick,
					handleClear: canClear ? handleClear : null,
					navigateByDay
				}}
			/>
		</div>
	);
};

export default DateFilterWrap;
